import "../../../styles/profile/profileHeader/profileHeaderWeb.scss";
import ProfileShareIcon from "../../../assets/images/icons/profile-share-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/icons/edit-icon.svg";
import React, { useRef, useState } from "react";
import EditImageIcon from "../../../assets/images/icons/edit-img-icon.svg";
import { Translate, withLocalize } from "react-localize-redux";
import BaseInput from "../../../elementKit/baseInput/BaseInput";
import TextAreaWithCounter from "../TextAreaWithCounter/TextAreaWithCounter";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import ShareProfileSheet from "../../shareProfileSheet/ShareProfileSheet";
import Notification from "../../notification/Notification";

function ProfileHeaderWeb(props) {
	const shareRef = useRef(null);
	const avatarImageInputRef = useRef(null);
	const bannerImageInputRef = useRef(null);
	const [isUpdating, setIsUpdating] = useState(false);

	function bannerBackgroundHandler() {
		if (!props.bannerUrl && !props.profileBannerEditImage)
			return {
				background: "#a0aec7",
				backgroundImage: "none",
			};
		return {
			backgroundImage: `url(${
				props.profileBannerEditImage
					? props.profileBannerEditImage.image
					: props.bannerUrl
			})`,
		};
	}

	function selectNewAvatarImage() {
		if (!props.editModeActive) return;
		avatarImageInputRef?.current?.click();
	}

	function selectNewBannerImage() {
		if (!props.editModeActive) return;
		bannerImageInputRef?.current?.click();
	}

	async function updateProfile() {
		setIsUpdating(true);
		await props.updateWalletProfile(
			props.profileName ?? undefined,
			props.profileDescription ?? undefined,
			props.profileAvatarEditImage?.base64 ?? undefined,
			props.profileBannerEditImage?.base64 ?? undefined,
			props.profileAvatarEditImage?.type ?? undefined,
			props.profileBannerEditImage?.type ?? undefined,
			props.linkedinProfileEditUrl ?? undefined
		);
		setIsUpdating(false);
	}

	return (
		<div
			id="profile-header-web"
			className={`flex-column ${props.editModeActive && "edit-mode-web"}`}
		>
			<div
				className="banner-background"
				onClick={() => {
					selectNewBannerImage();
				}}
				style={{
					cursor: props.editModeActive ? "pointer" : "default",
					...bannerBackgroundHandler(),
				}}
			>
				{props.editModeActive && (
					<img src={EditImageIcon} alt="edit" className="edit-banner-icon" />
				)}
			</div>

			<input
				type="file"
				multiple={false}
				id="file"
				accept="image/png, image/jpg, image/jpeg"
				ref={bannerImageInputRef}
				onChange={(e) => {
					if (e.target.files) {
						if (e.target.files[0].size > 1000000) {
							Notification({
								type: "error",
								text: props.translate("imageSizeGreaterThan1Mb").toString(),
							});
							return;
						}
						let image = URL.createObjectURL(e.target.files[0]);
						let type = e.target.files[0].type.split("/")[1];
						props.getBase64(e.target.files[0], (result) => {
							props.setProfileBannerEditImage({
								base64: result,
								image: image,
								type,
							});
						});
					}
				}}
				style={{ display: "none" }}
			/>
			<div className={`flex-column profile-details`}>
				<div
					className="flex-row jc-sb ai-fe avatar-buttons"
					style={{ width: "100%" }}
				>
					<img
						src={
							props.profileAvatarEditImage
								? props.profileAvatarEditImage.image
								: props.imageUrl
						}
						alt="profile"
						style={{
							cursor: props.editModeActive ? "pointer" : "default",
						}}
						className="profile-avatar"
					/>
					{props.editModeActive && (
						<img
							src={EditImageIcon}
							alt="edit"
							onClick={() => {
								selectNewAvatarImage();
							}}
							style={{ cursor: "pointer" }}
							className="edit-avatar-icon"
						/>
					)}
					<input
						type="file"
						multiple={false}
						id="file"
						accept="image/png, image/jpg, image/jpeg"
						ref={avatarImageInputRef}
						onChange={(e) => {
							if (e.target.files) {
								if (e.target.files[0].size > 1000000) {
									Notification({
										type: "error",
										text: props.translate("imageSizeGreaterThan1Mb").toString(),
									});
									return;
								}

								let image = URL.createObjectURL(e.target.files[0]);
								let type = e.target.files[0].type.split("/")[1];
								props.getBase64(e.target.files[0], (result) => {
									props.setProfileAvatarEditImage({
										base64: result,
										image: image,
										type,
									});
								});
							}
						}}
						style={{ display: "none" }}
					/>

					{props.editModeActive ? (
						<div className="profile-buttons-edit flex-row jc-fe">
							<BaseButton
								size="small"
								type="secondary"
								key={"cancel-changes"}
								loading={false}
								height={33.17}
								onClickAction={() => {
									if (isUpdating) return;
									props.cancelEditMode();
								}}
								className="cancel-changes-btn"
							>
								<Translate id="cancel" />
							</BaseButton>
							<BaseButton
								size="small"
								key={"apply-changes"}
								type="primary"
								onClickAction={updateProfile}
								className="apply-changes-btn"
								loading={isUpdating}
								height={33.17}
							>
								<Translate id="applyChanges" />
							</BaseButton>
						</div>
					) : (
						props.isLoggedInUserProfile && (
							<div className="profile-buttons flex-row jc-fe" ref={shareRef}>
								<BaseButton
									size="small"
									type="secondary"
									loading={false}
									height={33.17}
									onClickAction={props.enterEditMode}
									width={56}
								>
									<EditIcon className="customizable-icon" />
									{/* <img src={EditIcon} alt="edit" /> */}
								</BaseButton>

								<BaseButton
									size="small"
									type="primary"
									styles={{ marginLeft: "15px" }}
									className="share-profile-btn"
									loading={false}
									onClickAction={() => {
										props.setShareSheetOpen(!props.shareSheetOpen);
									}}
									height={33.17}
									width={56}
								>
									<img
										src={ProfileShareIcon}
										alt="share"
										width={15}
										height={19}
									/>
								</BaseButton>
							</div>
						)
					)}
				</div>
				{props.editModeActive ? (
					<div className="flex-column profile-info-edit ai-fs">
						<BaseInput
							width={398}
							height={58}
							key="profile-name"
							value={props.profileName}
							onChangeAction={(newName) => {
								props.setProfileName(newName);
							}}
						/>
						<TextAreaWithCounter
							value={props.profileDescription}
							onChange={(newDescription) => {
								props.setProfileDescription(newDescription);
							}}
							placeholder={props
								.translate("profileDescriptionPlaceholder")
								.toString()}
						/>
						<BaseInput
							key="linkedin-profile-url"
							className="linkedin-profile-input"
							width={398}
							height={58}
							placeholder={props.translate("linkedinProfileUrl").toString()}
							value={props.linkedinProfileEditUrl}
							onChangeAction={(newLinkedinUrl) => {
								props.setLinkedinProfileEditUrl(newLinkedinUrl);
							}}
						/>
					</div>
				) : (
					<div className="flex-column profile-info ai-fs">
						<span className="profile-name">{props.name}</span>
						<span className="profile-description">{props.description}</span>
						<span className="profile-credential-count">
							<span className="boldish">{props.credentialCount}</span>{" "}
							<Translate id="credentials" />
						</span>
					</div>
				)}
			</div>
			<ShareProfileSheet
				isMobile={false}
				addTranslation={props.addTranslation}
				sheetOpen={props.shareSheetOpen}
				onClose={props.handleShareSheetClose}
				translate={props.translate}
				{...props}
			/>
		</div>
	);
}

export default withLocalize(ProfileHeaderWeb);
